const SidebarHeading = ({ children }) => {
  return (
    <h2 className="mb-2 flex flex-row items-center uppercase">{children}</h2>
  )
}
export default SidebarHeading
